import { useFrame } from '@react-three/fiber'
import TWEEN from '@tweenjs/tween.js'
import { createContext, ReactChildren, ReactFragment, ReactPortal, useContext, useState } from 'react'
import useCappedFrame from '../../utils/hooks/useCappedFrames'

type TweenContextType = typeof TWEEN

export const TweenContext = createContext<TweenContextType>(TWEEN)

// Setup the animation loop.
// function animate(time: number) {
// 	requestAnimationFrame(animate)
// 	TWEEN.update(time)
// }
// requestAnimationFrame(animate)

const TweenProvider = ({ children }: { children: ReactChildren | ReactFragment | ReactPortal }) => {
  useCappedFrame((delta, time) => {
    TWEEN.update(time)
  })
  return <TweenContext.Provider value={TWEEN}>{children}</TweenContext.Provider>
}

export default TweenProvider

export const useTween = () => {
  const tween = useContext(TweenContext)
  return tween
}